import RaceDetail from './RaceDetail';

export default RaceDetail;
export { RaceDetail };
